export default __webpack_public_path__ + "static/media/640_portfolio03-it-web.18a375a1.png";